import { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import utils from '../../../utils/generalFunctions';
import academicService from "../../../services/academicService";
import { toast } from 'react-toastify';
import Loading from "../../../components/Loading";
import JornadaAnioPeriodoNivelCurso from "../../../components/Filters/JornadaAnioPeriodoNivelCurso";
import estudiantesService from "../../../services/estudiantesService";
import useCustomDataTableStyles from "../../../components/estilosDeDataTable";
import AsignaturasPerdidasActa from "../AsignaturaPerdida/AsignaturasPerdidasCurso";
import AsignaturasRecuperacionActa from "./AsignaturasRecuperacionCurso";

const AsignaturaRecuperadaRepo = () => {
    const filteReference = useRef(null);
    const initData ={
        schoolYearId: "0",
        journeyId:"0",
        periodId:"",
        educationLevelId: "0",
    };
    const [formData, setFormData] = useState(initData);
    const [periodos, setPeriodosList] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [course, setCourse] = useState(null);    
    const [estudiantes, setEstudiantes] = useState([]);    
    const [filterText, setFilterText] = useState('');
    const [actaInfo, setActaInfo] = useState(null);
    const [periodoSelected, setPeriodoSelected] = useState(null);
    //const [decimalesPlanilla, setDecimalesPlanilla] = useState(0);
    
    const updateForm = async (data) => {
        if (data.schoolYearId!==formData.schoolYearId){   
          await cargarPeriodos(data.schoolYearId);
        }
        setFormData(prevState => ({
            ...prevState,
            ...data
          }));
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const cargarPeriodos = async (schoolYearId) => {
        try {
            const schoolYear = await academicService.getYearById(schoolYearId);              
            if(schoolYear){
                setPeriodosList(schoolYear.periods)
            }            
        } catch (error) {
             console.error("Error al obtener información de año escolar:", error);
        }
    }

    // const fetchLoadGeneralParams = async () => {
    //     try {
    //       const parameters = await collectionsService.getParameters();
    //       const decimales = parameters.find(
    //         (op) => String(op.keyName) === "decimalesPlanilla"
    //       );
    //       if (decimales) {
    //         setDecimalesPlanilla(Number(decimales.value));
    //       }
    //     } catch (error) {
    //       console.error("Error al obtener parametros de formulario:", error);
    //     }
    // };
    
    //   useEffect(() => {
    //     fetchLoadGeneralParams();
    //   }, []);

    const generarCosolidadReporteTotal = async () =>{
        setActaInfo(null);
        const requiredFields = ['schoolYearId', 'journeyId', 'periodId','educationLevelId','courseId'];
        for (let field of requiredFields) {
            if (!formData[field] || formData[field]==='0') {
                toast.error("Por favor, completa todos los campos obligatorios.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                return;
            }
        }
        setShowLoading(true);
        try {
           const copyData = utils.copy(formData);
           copyData.periodName = periodos.find(p=>String(p.academicPeriodId)===String(copyData.periodId))?.periodName??"";
           const years = filteReference.current?.getSchoolYears();
           if(years){
                copyData.year = years.find(p=>String(p.schoolYearId)===String(copyData.schoolYearId))?.year??"";
           }
           const journeys = filteReference.current?.getJourneys();
           if(journeys){
                copyData.journey = journeys.find(p=>String(p.journeyId)===String(copyData.journeyId))?.name??"";
           }

           const courses = filteReference.current?.getCursos();
           if(courses){
                copyData.course = courses.find(p=>String(p.courseId)===copyData.courseId)?.name??"";
           }

           const educationLevels = filteReference?.current?.getEducationLeves();
           if (educationLevels.length > 0) {
                copyData.evaluationTypeId = educationLevels.find((c) => String(c.educationLevelId) === String(copyData.educationLevelId))?.evaluationTypeId;
           }
           
          const data = await estudiantesService.getEstudianteToNivelar(
            "",
            copyData.courseId,
            copyData.schoolYearId,
            copyData.periodId
          ); // Obtenemos los estudiantes de tu sistema
          
          if(data && data.students.length>0){
            data.students = data.students.filter(s=> s.areasNotes.filter( a=> a.subjectNotes.filter(s=>s.recuperationNote!==null && s.recuperationNote>0).length>0 ).length>0 );
            data.students = data.students.map(s=> { 
              s.areasNotes.map( a=> {
                              a.subjectNotes = a.subjectNotes.filter(s=>s.recuperationNote!==null && s.recuperationNote>0);
                                return a;
                              });
            return s;
          });
            setCourse(data);
            setEstudiantes(data.students);
          }else{
            toast.error("No se encontraron estudiantes con notas de recuperación.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setEstudiantes([]); 
          }
          
        } catch (error) {
          console.error("Error al obtener asistencias:", error);
        }
        setShowLoading(false);
    }

    const volverLista =  async () => {
        setActaInfo(null);
    };

    const generarActa =  async (student) => {
        setShowLoading(true);
        const copyData = utils.copy(formData);
        copyData.periodName = periodos.find(p=>String(p.academicPeriodId)===String(copyData.periodId))?.periodName??"";
        setPeriodoSelected({periodId:formData.periodId, periodName:copyData.periodName});
        setActaInfo(student);
        setShowLoading(false);
    };

    

    const columns = [
        { name: "Número", selector: "consecutive", sortable: true, 
        cell: (row, index) => <span>{index + 1}</span>, },      
        { name: "ID", selector: "identification", sortable:true,grow:"2.5",},
        { name: "Nombre completo", selector: "studentFullName", sortable:true,grow:"6"}, // Asumiendo que 'nombre' contiene tanto el nombre como el apellido
        {
          name: "Acciones",grow:"3",
          selector: "actions",
          cell: (row) => (
            <div className="actions-container justify-content-between align-items-center">
                <button
                    onClick={() => generarActa(row)}
                    className="btn-edit btn-sm ms-2"
                    title="Generar Acta">
                    <i class="fa-solid fa-scroll"></i>
                </button>
            </div>
          ),
        },
      ];

    const normalizeString = (str) => {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
    };

    const filteredItems = estudiantes?.filter((item) => {
        if (item) {
          const allData = `${item.fullName} ${item.identification} `;
          const normalizedFilterText = normalizeString(filterText);
          const normalizedItemName = normalizeString(allData);
          return normalizedItemName.includes(normalizedFilterText);
        }
        return item;
      });
    
    const customStyles = useCustomDataTableStyles();


    return (
        <>
          <div className="student-table-container p-3 filter-container">
            <h1>Reporte de recuperación</h1>
            <p>Selecciona los filtros para generar el reporte.</p>
            
                <div className="row">
                    <JornadaAnioPeriodoNivelCurso
                                callback={updateForm}
                                ref={filteReference}
                                loadTutoria={true}
                                loadCoordinators={true}
                                hideAsignatura={true}
                                properties={
                                    {
                                        className:'col-md-2 mb-2',
                                        id:'formReport2',
                                        filtro:false
                                    }
                                }
                            />
                        <div className="col-md-2 mb-1 margin-top-45">
                                <Button onClick={generarCosolidadReporteTotal} className="ml-2">Buscar</Button>
                        </div>
                </div>
          </div>
          {showLoading && <Loading />}

          {!showLoading  && course && (
            <>
            <div className=" mb-1 margin-top-10">
              <AsignaturasRecuperacionActa
                    course={course}
                    showSemi={(String(formData.journeyId)==="2")}
                />
                </div>
            </>
          )}
        </>
    );
};
  
export default AsignaturaRecuperadaRepo;